<div class="item">
  <img [src]="project.cover_foto.url"/>
  <div class="work-info">
    {{ project.title }}
  </div>
  <div class="overlay"></div>
</div>
